import * as ReactService from "@intech/react-service";
import { PlanoSaudeEntidade } from "../entidades/PlanoSaudeEntidade";

class PlanoSaude extends ReactService.BaseService {
  constructor() {
    super("PlanoSaude");
  }

  Buscar = () =>
    this.CreateRequest<PlanoSaudeEntidade[]>(ReactService.RequestType.GET, `Buscar`);

  BuscarDatas = () =>
    this.CreateRequest<PlanoSaudeEntidade[]>(ReactService.RequestType.GET, `BuscarDatas`);

  GerarRelatorio = (anoCalendario: number) =>
    this.CreateRequest<any>(ReactService.RequestType.GET, `GerarRelatorio/${anoCalendario}`, null, ReactService.ResponseType.Blob);

}

export const PlanoSaudeService = new PlanoSaude();
